import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InfoService } from '../info.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [ InfoService ]
})
export class ContactComponent extends BaseComponent implements OnInit {

  @ViewChild("header", {static: false}) header;

  constructor(private infoService: InfoService) {
    super();
  }

  ngOnInit() {
    
  }

}
